import { CompositeLayer, MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";

export class BuildingBuildingAlignLayer extends CompositeLayer {
    name = "xxx";
    componentName = "xxx";
    workspace = "";
    layerName = "";
    is3D = false;
    opacity = 100

    constructor(workspace, layerName, is3D, opacity) {
        super();

        this.workspace = workspace;
        this.layerName = layerName;
        this.is3D = is3D;
        this.opacity = opacity
    }

    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }

    getPalette(prop) {
        const value = prop.mtbAli

        if (value <= 0.91) {
            return [68, 1, 84]
        }
        if (value <= 2.56) {
            return [58, 82, 139]
        }
        if (value <= 5.62) {
            return [32, 144, 140]
        }
        if (value <= 12.66) {
            return [94, 201, 98]
        }

        return [253, 231, 37]
    }

    renderLayers() {
        const { zoom } = this.context.viewport;
        const dataSource = generateUrlGeoserverVector(this.workspace, this.layerName)

        return [
            new MVTLayer({
                id: 'BuildingAreaLayer1',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor: [0, 0, 0, 150],
                getFillColor: f => this.getPalette(f.properties),
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                getElevation: this.is3D ? d => d.properties.height : 0,
                terrainDrawMode: this.is3D ? 'offset' : '',
                extruded: this.is3D,

                getFilterValue: d => d.properties.area,
                filterRange: [[10000, 1000000]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],

                visible: zoom < 7.5,
                dataComparator: (a, b) => false
            }),
            new MVTLayer({
                id: 'BuildingAreaLayer2',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor: [0, 0, 0, 150],
                getFillColor: f => this.getPalette(f.properties),
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                getElevation: this.is3D ? d => d.properties.height : 0,
                terrainDrawMode: this.is3D ? 'offset' : '',
                extruded: this.is3D,

                getFilterValue: d => d.properties.area,
                filterRange: [[2000, 1000000]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],

                visible: zoom >= 7.5 && zoom < 9.5
            }),
            new MVTLayer({
                id: 'BuildingAreaLayer3',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor: [0, 0, 0, 150],
                getFillColor: f => this.getPalette(f.properties),
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                getElevation: this.is3D ? d => d.properties.height : 0,
                terrainDrawMode: this.is3D ? 'offset' : '',
                extruded: this.is3D,

                getFilterValue: d => d.properties.area,
                filterRange: [[500, 1000000]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                visible: zoom >= 9.5 && zoom < 12,
                dataComparator: (a, b) => false
            }),
            new MVTLayer({
                id: 'BuildingAreaLayer4',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor: [0, 0, 0, 50],
                getFillColor: f => this.getPalette(f.properties),
                getLineWidth: 1.0,
                lineWidthMinPixels: 1.0,
                pickable: true,
                getElevation: this.is3D ? d => d.properties.height : 0,
                terrainDrawMode: this.is3D ? 'offset' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],
                extruded: this.is3D,

                visible: zoom >= 12,
                dataComparator: (a, b) => false
            }),
        ]
    }
}